import * as errors from "../errors.js";
import { printLine, safeEval } from "../utilities.js";
import { state, modes } from "../state.js";
import { abs } from "../functions/abs.js";
import { asc } from "../functions/asc.js";
import { atn } from "../functions/atn.js";
import { cos } from "../functions/cos.js";
import { sin } from "../functions/sin.js";
import { tan } from "../functions/tan.js";
import { exp } from "../functions/exp.js";
import { log } from "../functions/log.js";
import { rnd } from "../functions/rnd.js";
import { val } from "../functions/val.js";
import { sqr } from "../functions/sqr.js";
import { str } from "../functions/str.js";
import { spc } from "../functions/spc.js";
import { len } from "../functions/len.js";
import { int } from "../functions/int.js";
import { time } from "../variables/time.js";

export const print = async (args) => {
    // Trim the args to remove leading and trailing spaces.
    args = args.trim();

    // Check if args are empty or undefined.
    if (args === undefined || args.length === 0) {
        await printLine();
        return;
    }

    // Preprocess the input to add concatenation operators where needed.
    let newArgs = preprocessInput(args);
    while (newArgs !== args) {
        args = newArgs;
        newArgs = preprocessInput(args);
    }
    args = newArgs;

    // Define the context for functions & variables.
    const context = { 
        ABS: abs, 
        ASC: asc,
        ATN: atn,
        COS: cos,
        SIN: sin,
        TAN: tan,
        EXP: exp,
        LOG: log,
        RND: rnd,
        VAL: val,
        SQR: sqr,
        STR$: str,
        SPC: spc,
        LEN: len,
        INT: int,
        get TI() { return time(); },
        get TIME() { return time(); }
    };

    let result;
    try {
        // Evaluate the preprocessed input.
        result = await safeEval(args, context);
        if (typeof result === "function") {
            result = await result(); // If the result is a function, call it.
            // If the result is a function, set result to 0.
            if (typeof result === "function") {
                result = 0;
            }
        }
    } catch (error) { // When an error occurs, set result to 0.
        if (error instanceof errors.BaseError) {
            await error.handleError();
            return;
        } else {
            await SyntaxError.handleError();
            return;
            // console.error(error);
            // result = 0;
        }
    }

    // Print the result.
    if (!isNaN(result) && result >= 0) {
        result = " " + String(result);
    }
    
    // Print the result, splitting it into chunks of 40 characters if necessary.
    // Let the result string be a maximum length of 255 characters.
    result = String(result);
    if (result.length > state.maxStringLength) {
        result = result.slice(0, state.maxStringLength);
    }
    
    for (let i = 0; i < result.length; i += state.maxLineLength) {
        await printLine(result.slice(i, i + state.maxLineLength));
    }

    if (state.mode === modes.INPUT) {
        // If in input mode, print the prompt.
        await printLine();
    }
};

/**
 * Preprocesses the input to add concatenation operators where needed.
 * @param {string} input - The input string to preprocess.
 * @returns {string} The preprocessed input.
 */
const preprocessInput = (input) => {
    // Add a "+" between a string, function call, or number if no operator is present.
    return input
        // Handle cases where there are no spaces between tokens.
        .replace(/(".*?"|\d+)(\w+\()/g, '$1+$2') // String/number followed by a function call.
        .replace(/(\w+\))(".*?"|\d+)/g, '$1+$2') // Function call followed by a string/number.
        .replace(/(".*?"|\w+\(.*?\)|\d+)\s+(".*?"|\w+\(.*?\)|\d+)/g, '$1+$2'); // Handle spaces between tokens.
};